import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filter: {
    receiptDaysTab: "today",
    receiptStartDate: "",
    receiptEndDate: "",
    status: "All",
    shipingTab: { label: "All", value: "" },
    selectedManagerID: null,
    selectedAccount: {},
    selectedRadio: { label: "Order ID", value: "orderId" },
    keyword: "",
    // debouncedKeyword: "",
    selectedYear: "2025-2026",
  },
  pagination: {
    page: 1,
    pages: 1,
    // limit: 1,
  },
};

const receiptSlice = createSlice({
  name: "receipts",
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload };
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    resetAll: () => initialState,
  },
});

export const { setFilter, setPagination, resetAll } = receiptSlice.actions;

export default receiptSlice.reducer;
